import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import SideBySideTextAndAssetAdvancedFieldsConfig from "segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config";
import AssetFieldsConfig from "components/core/asset/fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    ...FullParagraphAdvancedFieldsConfig,
    ...AssetAdvancedConfig,
    ...SideBySideTextAndAssetAdvancedFieldsConfig,
    nestedBoardItems: {
      type: FIELD_TYPES.NESTED,
      label: "Embedded Board",
      fields: {
        addLiveBoardTextAndAsset: {
          type: FIELD_TYPES.BOOLEAN,
          label: "Add Live Board Experience"
        },
        boardBannerText: {
          type: FIELD_TYPES.TEXT,
          label: "Board Banner Text",
          translatable: true
        },
        embeddedBoardTitle: {
          type: FIELD_TYPES.TEXT,
          label: "Embedded Board Title",
          translatable: true
        },
        addSecondLiveBoardSignUpButton: {
          type: FIELD_TYPES.BOOLEAN,
          label: "Add Second Sign Up Button In The Live Board"
        },
        liveBoardToolTipText: {
          type: FIELD_TYPES.TEXT,
          label: "Live Board Tooltip Text"
        },
        parallaxAsset: {
          type: FIELD_TYPES.NESTED,
          label: "Parallax Asset- IN TEST - DON'T USE",
          fields: {
            position: {
              type: FIELD_TYPES.COMBO,
              label: "Position",
              options: ["top", "center", "bottom"]
            },
            fitToContainer: {
              type: FIELD_TYPES.BOOLEAN,
              label: "Fit to container"
            },
            ...AssetFieldsConfig
          }
        },
        gapBetweenAssets: {
          type: FIELD_TYPES.TEXT,
          label: "Gap Between Assets(px)"
        },
        fullParagraphMarginTop: {
          type: FIELD_TYPES.TEXT,
          label: "Full Paragraph Margin Top"
        },
        fullParagraphMarginBottom: {
          type: FIELD_TYPES.TEXT,
          label: "Full Paragraph Margin Bottom"
        }
      }
    }
  }
};
